import { Zap, ShieldCheck, Boxes, Network } from "lucide-react";

const pillars = [
  {
    Icon: Zap,
    title: "Real-time by Design",
    desc: "Designed for low-latency processing and continuous data flow, enabling real-time execution across services, APIs, and integrations",
  },
  {
    Icon: ShieldCheck,
    title: "Production-first Engineering",
    desc: "Built for live environments from day one, with proven reliability in 24/7, mission-critical systems",
  },
  {
    Icon: Boxes,
    title: "Platform, not Projects",
    desc: "A cohesive suite built on a high-performance integration platform, replacing isolated and custom one-off systems",
  },
  {
    Icon: Network,
    title: "Deep System Understanding",
    desc: "Deep expertise in integration, observability, architecture, and data for full system control",
  },
];

export const WhyBaneTech = () => {
  return (
    <section id="why" className="relative py-24 md:py-32">
      <div className="container">
        <div className="max-w-2xl mb-16">
          <p className="font-mono text-xs uppercase tracking-widest text-primary mb-4">Why Bane Tech</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold leading-tight">
            Built for Performance at Scale.
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            Bane Tech builds and operates high-performance platforms for real-time, mission-critical systems engineered for low latency, reliability, and scale.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {pillars.map((p) => (
            <div
              key={p.title}
              className="rounded-2xl border-gradient bg-card-gradient p-1 transition-transform hover:-translate-y-1"
            >
              <div className="rounded-[14px] bg-surface p-8 h-full">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 border border-primary/30 mb-5">
                  <p.Icon className="h-5 w-5 text-primary" strokeWidth={1.75} />
                </div>
                <h3 className="font-display text-xl font-semibold mb-2">
                  <span className="text-foreground/90">{p.title}</span>
                </h3>
                <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                  {p.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
